import React from 'react';
import TweenOne from 'rc-tween-one';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';

/* replace-start */
import './index.less';
/* replace-end */
class Feature18 extends React.PureComponent {
  render() {
    const { ...tagProps } = this.props;
    const { dataSource } = tagProps;
    delete tagProps.dataSource;
    delete tagProps.isMobile;

    function getItem() {
      const itemLists = dataSource.content.right.box.children;
      return itemLists.map((key) => {
        const { title, img, ...other } = key;
        return (
          <div {...other} key={title.children}>
            {/* <div {...img}>
              <img src={img.children} alt="" />
            </div> */}
            <div {...title}>
              <span dangerouslySetInnerHTML={{ __html: title.children }} />
            </div>
          </div>
        );
      }
      );
    }

    return (
      <div
        {...tagProps}
        {...dataSource.wrapper}
      >
        <div {...dataSource.page}>
          <OverPack
            {...dataSource.content}
          >
            <TweenOne
              animation={{
                x: 0,
                duration: 1000,
              }}
              style={{ transform: 'translateX(-80px)' }}
              key="img"
              {...dataSource.content.left}
              data-edit="text,image"
            >
              <div className="bk" />
              <img src={dataSource.content.left.children} width="100%" alt="img" />
            </TweenOne>
            <TweenOne
              animation={{
                x: 0,
                duration: 1000,
              }}
              style={{ transform: 'translateX(80px)' }}
              {...dataSource.content.right}
            >
              <div {...dataSource.content.right.title}>
                <span dangerouslySetInnerHTML={{ __html: dataSource.content.right.title.children }} />
              </div>
              <div {...dataSource.content.right.box}>
                {getItem()}
              </div>
            </TweenOne>
          </OverPack>
        </div>
      </div>
    );
  }
}
export default Feature18;
